
    import * as React from 'react';

    const ReturnsAlt16 = ({ color = 'currentcolor', height = '16px', width = '16px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 16 16" style={svgStyle}><path d="M9.838 11.371c2.216-.038 4.001-1.756 4.001-3.871 0-2.138-1.825-3.872-4.076-3.872H6.237c-2.68 0-4.076 1.565-4.076 3.872 0 1.998 1.905 3.872 4.076 3.872H6.5V12h-.263C3.695 12 1.5 9.84 1.5 7.5 1.5 4.867 3.165 3 6.237 3h3.526C12.379 3 14.5 5.015 14.5 7.5c0 2.27-1.769 4.147-4.068 4.455l2.344.935-.278.696-4.035-1.608 2.57-3.503.604.444-1.8 2.452z" /></svg>
        </div>
      );
    };

    ReturnsAlt16.displayName = 'ReturnsAlt16';

    export default ReturnsAlt16;
  